import { useEffect } from 'react'
import { WEBSITE_USE_API } from '../config'
import { useWebsiteStore } from '../store/useWebsiteStore'

/**
 * Hydrates the store from the backend when the seam is open, and does nothing at
 * all when it is not. Turning `WEBSITE_USE_API` on is the only change needed
 * here once `menu_core_be` has a `websites` domain.
 */
export function useWebsiteQuery() {
  const importDocument = useWebsiteStore(s => s.importDocument)

  useEffect(() => {
    if (WEBSITE_USE_API) {
      // The GET goes here, mapped beside the API file exactly as
      // features/floor-plan/api does it. Absent rather than stubbed: a fake
      // request that resolves makes the page look wired when it is not.
    }
  }, [importDocument])

  return { isBackedByApi: WEBSITE_USE_API }
}
